export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14047.9694e394.jpg";